"use client";

import React from "react";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = ["Minimum aşındırma ile doğal diş yapısının korunması", "Işık geçirgenliği sayesinde kusursuz doğal görünüm", "Renk değiştirmeyen, leke tutmayan porselen yüzeyler", "Kısa sürede tamamlanan kişiye özel gülüş tasarımı"];
export default function EnhanceTheBeautyOfYourProperty() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="149057" id="lamine-diş-tedavisi-bilgi" className="bg-background py-20 lg:py-32 overflow-hidden" ref={sectionRef}>
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
          
          {/* Left Column: Image with offset border */}
          <div className={`relative min-h-[400px] lg:min-h-[600px] rounded-sm overflow-hidden border border-primary/20 shadow-[16px_16px_0px_0px_rgba(184,158,96,0.15)] transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <img src="https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/laminate-veneer.jpg" alt="Lamine diş tedavisi sonrası doğal gülüş tasarımı" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
            {/* Light-leak effect overlay */}
            <div className="absolute inset-0 bg-gradient-to-tr from-primary/5 via-transparent to-white/10 pointer-events-none" />
          </div>

          {/* Right Column: Editorial Content */}
          <div className={`bg-background text-foreground rounded-sm p-10 md:p-14 lg:p-16 flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="inline-flex items-center gap-2 mb-6">
              <span className="h-[2px] w-10 bg-primary block"></span>
              <span className="text-primary font-sans font-semibold tracking-widest uppercase text-xs">
                Premium Estetik Diş Hekimliği
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-6 leading-[1.1] tracking-tight text-foreground">
              Lamine Diş <span className="text-primary">Tedavisi</span>
            </h2>

            <p className="text-muted-foreground text-lg md:text-xl mb-10 leading-relaxed font-sans max-w-xl">
              Porselen yaprak lamine süreci ile gülüşünüzü yeniden tanımlıyoruz. Diş yüzeyine minimum müdahale ile uygulanan bu yüksek teknolojili çözüm, hem estetik hem de fonksiyonel olarak hayalinizdeki görünüme kavuşmanızı sağlar.
            </p>

            <ul className="space-y-5 mb-12">
              {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                  <CheckCircle2 className="w-5 h-5 text-primary shrink-0 mt-1" />
                  <span className="text-foreground/90 text-lg font-medium font-sans">
                    {feature}
                  </span>
                </li>)}
            </ul>

            <div className="mt-auto pt-4">
              <Button asChild size="lg" className="bg-transparent border-2 border-primary text-primary hover:bg-primary/5 rounded-sm px-8 h-14 text-lg font-semibold transition-all shadow-sm">
                <Link to="/ContactPage" className="inline-flex items-center gap-2">
                  Randevu Alın
                  <ArrowRight className="w-5 h-5" />
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}